export default function WhatIsDelegation() {
  return (
    <section id="what-is" className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что такое эффективное делегирование
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Делегирование — это не просто передача задачи сотруднику. Это управленческий инструмент, который включает несколько обязательных элементов
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {[
            { title: 'Выбор задачи', desc: 'Не каждая задача подходит для делегирования. Важно определить, какие задачи можно и нужно передавать сотрудникам.' },
            { title: 'Выбор сотрудника', desc: 'Учитываются компетенции, текущая загрузка, мотивация и потенциал развития конкретного сотрудника.' },
            { title: 'Ожидаемый результат', desc: 'Сотрудник должен понимать не процесс, а именно результат — что должно получиться в итоге.' },
            { title: 'Сроки', desc: 'Определяются конкретные сроки: когда задача должна быть выполнена и когда — промежуточные контрольные точки.' },
            { title: 'Полномочия', desc: 'Сотрудник получает чёткие границы: что он может решать сам, а что требует согласования с руководителем.' },
            { title: 'Критерии качества', desc: 'Заранее определено, какой результат считается хорошим. Это убирает субъективность при оценке.' },
            { title: 'Контрольные точки', desc: 'Договорённость о том, когда и как проверяется промежуточный результат, чтобы избежать сюрпризов.' },
            { title: 'Обратная связь', desc: 'По итогам выполнения задачи руководитель даёт обратную связь — что получилось хорошо, что можно улучшить.' },
            { title: 'Ответственность', desc: 'Сотрудник принимает ответственность за результат, а не просто выполняет поручение.' },
          ].map((item) => (
            <div key={item.title} className="bg-gray-50 rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors">
              <h3 className="font-bold text-gray-900 text-sm mb-1.5">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 text-center max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-teal-800 leading-relaxed mb-4">
            Разница между простым поручением и делегированием:
          </p>
          <div className="grid sm:grid-cols-2 gap-4 text-left">
            <div className="bg-red-50 rounded-lg border border-red-200 p-4">
              <p className="text-red-700 font-semibold text-sm mb-1">«Сделай это»</p>
              <p className="text-red-600 text-xs leading-relaxed">Сотрудник не понимает ни цели, ни критериев качества, ни своих полномочий. Результат непредсказуем.</p>
            </div>
            <div className="bg-green-50 rounded-lg border border-green-200 p-4">
              <p className="text-green-700 font-semibold text-sm mb-1">«Вот результат, который нам нужен, вот срок, критерии и зона ответственности»</p>
              <p className="text-green-600 text-xs leading-relaxed">Сотрудник понимает задачу полностью и может самостоятельно принимать решения в рамках своих полномочий.</p>
            </div>
          </div>
          <p className="text-sm md:text-base text-teal-800 leading-relaxed mt-5 font-semibold">
            Цель делегирования — не избавиться от работы, а увеличить управленческую ёмкость руководителя и самостоятельность команды.
          </p>
        </div>
      </div>
    </section>
  );
}